import { Component, Prop } from 'vue-property-decorator';
import PropertyCommons from '@/components/commons/property.model';

@Component
export default class TagsComponent extends PropertyCommons {
  @Prop({ required: true })
  public value!: string[];

  @Prop({ default: null })
  public label: string;

  @Prop({ default: 'primary' })
  public variant: string;

  @Prop({ default: 'sm' })
  public size: string;

  @Prop({ default: 5 })
  public limit: number;

  @Prop({ default: 'ingrese tags' })
  public placeholder: string;

  get tags(): string[] {
    return this.value;
  }
  set tags(newValue: string[]) {
    this.$emit('input', newValue);
  }
}
